export enum IntakeType {
  Appointment = 'appointment',
  ThirdPartyProvider = 'third_party_provider'
}
